import type { BarometerCar } from '@autobid/ui/types/Car'
import type { FormKitNode } from '@formkit/core'

export function inputBidValidation(node: FormKitNode, car: BarometerCar) {
  return bidValidation(
    Number(node.value),
    car,
  )
}

export function bidValidation(value: number, car: BarometerCar) {
  if (!car.price.current) {
    return true
  }
  const rest = value - car.price.current
  return rest % getMinimalBidStep(car.bidOptions) === 0
}

export function getMinimalBidStep(bidOptions: number[]) {
  return Math.min(...bidOptions)
}
